"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PutBucketMetricsConfigurationInput_1 = require("./PutBucketMetricsConfigurationInput");
var PutBucketMetricsConfigurationOutput_1 = require("./PutBucketMetricsConfigurationOutput");
var ServiceMetadata_1 = require("./ServiceMetadata");
exports.PutBucketMetricsConfiguration = {
    metadata: ServiceMetadata_1.ServiceMetadata,
    name: "PutBucketMetricsConfiguration",
    http: {
        method: "PUT",
        requestUri: "/{Bucket}?metrics"
    },
    input: {
        shape: PutBucketMetricsConfigurationInput_1.PutBucketMetricsConfigurationInput
    },
    output: {
        shape: PutBucketMetricsConfigurationOutput_1.PutBucketMetricsConfigurationOutput
    },
    errors: []
};
//# sourceMappingURL=PutBucketMetricsConfiguration.js.map